var _Base = require('./_Base');
 /**
  * @extends Base widget
  * @class
  */
var CourseUpdate = _Base.extend(
  /** @lends _Base.prototype */
  {
    init: function () {
      this.$el.on('change', this.onChange.bind(this));
      this.$el.trigger('change');
    },
    onChange: function () {
      this.$selectedOption = this.$el.find('option:checked');
      if (this.$selectedOption.length && this.$selectedOption.data('price')) {
        this.updateValues();
      } else {
        this.hideSummary();
      }
    },
    hideSummary: function () {
      $('[data-course-summary]').hide();
      $('[data-course-title]').hide();
    },
    updateValues: function () {
      $('[data-course-summary]').show();
      $('[data-course-title]').show();
      $('[data-course-title]').text(this.$selectedOption.text());
      $('[data-course-price]').text(this.$selectedOption.data('price'));
      $('[data-course-fees]').text(this.$selectedOption.data('fees'));
      $('[data-course-total]').text(this.$selectedOption.data('total'));
      $('[data-course-price-label]').text(this.$selectedOption.data('priceLabel'));
      $('[data-course-fee-label]').text(this.$selectedOption.data('feeLabel'));

      if (this.$selectedOption.data('price') === '') {
        $('[data-course-pricerow]').hide();
      }
      if (this.$selectedOption.data('fees') === '') {
        $('[data-course-feesrow]').hide();
      }
    },
});

module.exports = CourseUpdate;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/CourseUpdate.js
 ** module id = 331
 ** module chunks = 1
 **/